import { ArrowBack, ArrowForward, CalendarMonthOutlined,} from "@mui/icons-material";
import { IconButton, List, ListItem, ListItemText, MenuItem, Popover, Select, Typography,} from "@mui/material";
import { Box } from "@mui/system";
import { DateCalendar, LocalizationProvider,} from "@mui/x-date-pickers";
import { DateRangeCalendar } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { addDays, endOfDay, format, startOfDay, subDays } from "date-fns";
import { addMonths, addWeeks, endOfMonth, endOfWeek, startOfMonth, startOfWeek, subMonths, subWeeks,} from "date-fns";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTheme } from "../../ThemeContext";

const predefinedRanges = [
  { label: "Day", 
    startDate: new Date(), 
    endDate: new Date() 
  },
  {
    label: "Week",
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
  },
  {
    label: "Month",
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(),
  },
  //   {
  //     label: "Range",
  //   },
  //   {
  //     label: "Project Span",
  //   },
];

const months = Array.from({ length: 12 }, (_, i) => ({
  label: format(new Date(2024, i, 1), "MMMM"),
  value: i,
}));
export const OTSheetCalender = ({
  selectionRange,
  setSelectionRange,
  projectSpan,
  setProjectSpan,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState(
    selectionRange.startDate.getFullYear()
  );
  const [selectedMonth, setSelectedMonth] = useState(
    selectionRange.startDate.getMonth()
  );

  const { isDarkMode } = useTheme();
  const [showMonthPicker, setShowMonthPicker] = useState(
    projectSpan === "month" ? true : false
  );
  const [showWeekPicker, setShowWeekPicker] = useState(
    projectSpan === "week" ? true : false
  );
  const [showDatePicker, setshowDatepicker] = useState(
    projectSpan === "day" ? true : false
  );
  const [showDateRangePicker, setShowDateRangePicker] = useState(
    projectSpan === "range" ? true : false
  );
  const [selectedRange, setSelectedRange] = useState([null, null]);

  const handleApply = () => {
    if (selectedRange[0] && selectedRange[1]) {
      const startDate = new Date(selectedRange[0]);
      const endDate = new Date(selectedRange[1]);

      setSelectionRange({
        startDate: startDate,
        endDate: endDate,
        key: "selection",
      });

      setProjectSpan("range");
      setOpen(false);
    }
  };
  const handleSetCurrentDate = () => {
    const today = new Date();
    setSelectionRange({ startDate: today, endDate: today, key: "selection" });
    setProjectSpan("day");
    setOpen(false);
  };

  const handleSetCurrentWeek = () => {
    const today = new Date();
    const start = startOfWeek(today);
    const end = endOfWeek(today);
    setSelectionRange({ startDate: start, endDate: end, key: "selection" });
    setProjectSpan("week");
    setOpen(false);
  };

  const handleSetCurrentMonth = () => {
    const today = new Date();
    const start = startOfMonth(today);
    const end = endOfMonth(today);
    setSelectionRange({ startDate: start, endDate: end, key: "selection" });
    setProjectSpan("month");
    setOpen(false);
  };
  useEffect(() => {
    if (selectionRange?.startDate && selectionRange?.endDate) {
      setSelectedYear(new Date(selectionRange.startDate).getFullYear());
      setSelectedMonth(new Date(selectionRange.startDate).getMonth());

      // for range picker
      setSelectedRange([selectionRange.startDate, selectionRange.endDate]);

      // for single-day picker, you might want to force showDatePicker true
      if (projectSpan === "day") {
        setshowDatepicker(true);
        setShowWeekPicker(false);
        setShowMonthPicker(false);
        setShowDateRangePicker(false);
      }
      if (projectSpan === "week") {
        setShowWeekPicker(true);
        setShowMonthPicker(false);
        setshowDatepicker(false);
        setShowDateRangePicker(false);
      }
      if (projectSpan === "month") {
        setShowMonthPicker(true);
        setShowWeekPicker(false);
        setshowDatepicker(false);
        setShowDateRangePicker(false);
      }
      if (projectSpan === "range") {
        setShowDateRangePicker(true);
        setShowWeekPicker(false);
        setShowMonthPicker(false);
        setshowDatepicker(false);
      }
    }
  }, [selectionRange, projectSpan]);

  const handlePredefinedSelect = (range) => {
    if (!range.label || typeof range.label !== "string") return;

    if (range.label === "Month") {
      setShowMonthPicker(true);
      setShowWeekPicker(false);
      setShowDateRangePicker(false);
      setshowDatepicker(false);
    } else if (range.label === "Week") {
      setShowWeekPicker(true);
      setShowMonthPicker(false);
      setshowDatepicker(false);
      setShowDateRangePicker(false);
    } else if (range.label === "Range") {
      setShowDateRangePicker(true);
      setShowWeekPicker(false);
      setShowMonthPicker(false);
      setshowDatepicker(false);
    } else if (range.label === "Day") {
      setShowDateRangePicker(false);
      setshowDatepicker(true);
      setShowWeekPicker(false);
      setShowMonthPicker(false);
    } else if (range.label === "Project Span") {
      setProjectSpan("project_span");
      setOpen(false);
      setSelectionRange({
        startDate: null,
        endDate: null,
        key: "selection",
      });
      return;
    } else {
      setShowMonthPicker(false);
      setShowWeekPicker(false);
      setShowDateRangePicker(false);
      setshowDatepicker(false);
      setSelectionRange({
        startDate: range.startDate,
        endDate: range.endDate,
        key: "selection",
      });
    }
    setOpen(true);
  };

  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
    setSelectionRange({
      startDate: startOfMonth(new Date(selectedYear, month, 1)),
      endDate: endOfMonth(new Date(selectedYear, month, 1)),
      key: "selection",
    });
    setProjectSpan("month");
    setOpen(false);
  };
  const handleDateChange = (newRange) => {
    setSelectedRange(newRange);

    if (newRange[0] && newRange[1]) {
      console.log(
        `From Date: ${selectedRange}, To Date: ${dayjs(newRange[1]).format(
          "DD-MM-YYYY"
        )}`
      );
    }
  };
  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 9; // 10 years back
  const maxYear = currentYear;

  const handleWeekSelect = (date) => {
    const start = startOfWeek(date);
    const end = endOfWeek(date);
    setSelectionRange({ startDate: start, endDate: end, key: "selection" });
    setOpen(false);
    setProjectSpan("week");
  };

  const handleDateSelect = (date) => {
    setSelectionRange({
      startDate: date,
      endDate: date,
      key: "selection",
    });
    setProjectSpan("day");
    setOpen(false); // Close the popover after selection
  };

  const handlePrevPeriod = () => {
    let newStartDate, newEndDate;

    if (projectSpan === "month") {
      newStartDate = startOfMonth(subMonths(selectionRange.startDate, 1));
      newEndDate = endOfMonth(subMonths(selectionRange.startDate, 1));
    } else if (projectSpan === "day") {
      newStartDate = startOfDay(subDays(selectionRange.startDate, 1));
      newEndDate = endOfDay(subDays(selectionRange.startDate, 1));
    } else {
      newStartDate = subWeeks(selectionRange.startDate, 1);
      newEndDate = subWeeks(selectionRange.endDate, 1);
    }

    setSelectionRange({
      startDate: newStartDate,
      endDate: newEndDate,
      key: "selection",
    });

    //  triggerFilterWithUpdatedDates(newStartDate, newEndDate);
  };

  const handleNextPeriod = () => {
    let newStartDate, newEndDate;

    if (projectSpan === "month") {
      newStartDate = startOfMonth(addMonths(selectionRange.startDate, 1));
      newEndDate = endOfMonth(addMonths(selectionRange.startDate, 1));
    } else if (projectSpan === "day") {
      newStartDate = startOfDay(addDays(selectionRange.startDate, 1));
      newEndDate = endOfDay(addDays(selectionRange.startDate, 1));
    } else {
      newStartDate = addWeeks(selectionRange.startDate, 1);
      newEndDate = addWeeks(selectionRange.endDate, 1);
    }

    setSelectionRange({
      startDate: newStartDate,
      endDate: newEndDate,
      key: "selection",
    });

    // triggerFilterWithUpdatedDates(newStartDate, newEndDate);
  };

  return (
    <Box display="flex" alignItems="center" gap={2}>
      {!(projectSpan === "range" || projectSpan === "project_span") && (
        <IconButton onClick={handlePrevPeriod}>
          <ArrowBack />
        </IconButton>
      )}

      <IconButton onClick={() => setOpen(true)}>
        <CalendarMonthOutlined />
      </IconButton>
      <Typography
        variant="body1"
        onClick={() => setOpen(true)}
        sx={{
          cursor: "pointer",
          fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }, // Smaller font size on extra-small devices
        }}
      >
        {projectSpan === "day" ? (
          <>{format(selectionRange.startDate, "MMM d, yyyy")}</>
        ) : projectSpan === "project_span" ? (
          "Project Span"
        ) : (
          <>
            {format(selectionRange.startDate, "MMM d, yyyy")} -{" "}
            {format(selectionRange.endDate, "MMM d, yyyy")}
          </>
        )}
      </Typography>

      {!(projectSpan === "range" || projectSpan === "project_span") && (
        <IconButton onClick={handleNextPeriod}>
          <ArrowForward />
        </IconButton>
      )}

      {/* Popover for Date Picker or Month Picker */}
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorReference="none"
        PaperProps={{
          style: {
            width: "auto", // ✅ Auto-adjust width
            minWidth: "400px", // ✅ Set a minimum width
            maxWidth: "900px", // ✅ Set a maximum width if needed
            padding: "10px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            // flexWrap: "wrap", // ✅ Allow it to wrap content
          },
        }}
      >
        {/* Left Panel: Predefined Views */}
        <Box
          sx={{
            width: "150px",
            borderRight: "1px solid #ddd",
            padding: "10px",
          }}
        >
          {/* <Typography variant="h6" sx={{ marginBottom: 1 }}>
                Select Range
              </Typography> */}
          <List>
            {predefinedRanges.map((range, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handlePredefinedSelect(range)}
                sx={{
                  borderBottom:
                    (range.label === "Month" && showMonthPicker) ||
                    (range.label === "Week" && showWeekPicker) ||
                    (range.label === "Day" && showDatePicker) ||
                    (range.label === "Range" && showDateRangePicker)
                      ? "3px solid rgba(18, 183, 159, 1)" // ✅ Green underline for active
                      : "none",
                }}
              >
                <ListItemText
                  primary={range.label}
                  sx={{
                    color:
                      (range.label === "Month" && showMonthPicker) ||
                      (range.label === "Week" && showWeekPicker) ||
                      (range.label === "Day" && showDatePicker) ||
                      (range.label === "Range" && showDateRangePicker)
                        ? "rgba(18, 183, 159, 1)" // ✅ Green text for active
                        : "inherit",
                    fontWeight:
                      (range.label === "Month" && showMonthPicker) ||
                      (range.label === "Week" && showWeekPicker) ||
                      (range.label === "Day" && showDatePicker) ||
                      (range.label === "Range" && showDateRangePicker)
                        ? "bold" // ✅ Bold text for active
                        : "normal",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>

        {/* Right Panel: Date Picker OR Month Picker */}
        <Box sx={{ flexGrow: 1, padding: "10px" }}>
          {showMonthPicker ? (
            <div className="container">
              {/* Year Selection */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* Previous Year Button (Disabled if selectedYear == minYear) */}
                <IconButton
                  onClick={() => setSelectedYear((prev) => prev - 1)}
                  disabled={selectedYear === minYear}
                  style={{
                    cursor:
                      selectedYear === minYear ? "not-allowed" : "pointer",
                  }}
                >
                  <ArrowBack />
                </IconButton>

                {/* Year Dropdown */}
                <Select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                  // className="form-select w-auto"
                >
                  {Array.from({ length: 10 }, (_, i) => {
                    const year = minYear + i;
                    return (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    );
                  })}
                </Select>

                {/* Next Year Button (Disabled if selectedYear == maxYear) */}
                <IconButton
                  onClick={() => setSelectedYear((prev) => prev + 1)}
                  disabled={selectedYear === maxYear}
                  style={{
                    cursor:
                      selectedYear === maxYear ? "not-allowed" : "pointer",
                  }}
                >
                  <ArrowForward />
                </IconButton>
              </div>

              {/* Month Selection */}
              <div className="row">
                {months.map((month) => (
                  <div className="col-3 p-3" key={month.value}>
                    <div
                      className="d-flex p-2 align-items-center justify-content-center flex-wrap rounded-5"
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          selectedMonth === month.value
                            ? "rgba(18, 183, 159, 1)"
                            : "transparent",
                        color: selectedMonth === month.value ? "#fff" : "#000",
                        transition: "0.3s",
                      }}
                      onClick={() => handleMonthSelect(month.value)}
                    >
                      <Typography>{month.label}</Typography>
                    </div>
                  </div>
                ))}
                <div className="col-12">
                  <div className="d-flex  mt-2 align-items-center justify-content-between gap-5">
                    <p className=" enterHourse" onClick={handleSetCurrentMonth}>
                      current Month
                    </p>
                    {/* <p
                      className=" enterHourse"
                      onClick={() => handleDateSelect(selectionRange.startDate)}
                    >
                      {" "}
                      ok
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          ) : showWeekPicker ? (
            <div className="col-12">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateCalendar
                  value={selectionRange.startDate}
                  onChange={handleWeekSelect}
                  sx={{
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    color: isDarkMode ? "#fff" : "rgba(18, 183, 159, 1)",
                    borderRadius: 2,
                    "& .MuiPickersDay-root": {
                      color: isDarkMode ? "#fff" : "#111",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "rgba(18, 183, 159, 1) !important",
                      color: "#fff",
                    },
                    "& .MuiPickersDay-root.Mui-selected": {
                      backgroundColor: "#ff8800",
                      color: "#fff",
                    },
                  }}
                />
              </LocalizationProvider>
              <div className="d-flex  mt-2 align-items-center justify-content-between gap-5">
                <p className=" enterHourse" onClick={handleSetCurrentWeek}>
                  current Week
                </p>
                {/* <p
                  className=" enterHourse"
                  // onClick={}
                >
                  {" "}
                  ok
                </p> */}
              </div>
            </div>
          ) : showDatePicker ? (
            <div className="col-12 ">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateCalendar
                  value={selectionRange.startDate}
                  // onChange={(date) => {
                  //   setSelectionRange({
                  //     startDate: date,
                  //     endDate: date,
                  //     key: "selection",
                  //   });
                  // }}
                  onChange={handleDateSelect}
                  sx={{
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    color: isDarkMode ? "#fff" : "rgba(18, 183, 159, 1)",
                    borderRadius: 2,
                    "& .MuiPickersDay-root": {
                      color: isDarkMode ? "#fff" : "#111",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "rgba(18, 183, 159, 1) !important",
                      color: "#fff",
                    },
                    "& .MuiPickersDay-root.Mui-selected": {
                      backgroundColor: "#ff8800",
                      color: "#fff",
                    },
                  }}
                />
              </LocalizationProvider>
              {/* <div className=" col-12"> */}
              <div className="d-flex  mt-2 align-items-center justify-content-between gap-5">
                <p className=" enterHourse" onClick={handleSetCurrentDate}>
                  Today
                </p>
              </div>
            </div>
          ) : (
            showDateRangePicker && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateRangeCalendar"]}>
                    <DateRangeCalendar
                      value={selectedRange}
                      onChange={handleDateChange}
                    />
                  </DemoContainer>
                </LocalizationProvider>

                {/* Apply Button */}
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    className=" add_btn"
                    onClick={handleApply}
                    sx={{ alignSelf: "flex-end", mt: 1 }}
                  >
                    Apply
                  </button>
                </div>
              </Box>
            )
          )}
        </Box>
      </Popover>
    </Box>
  );
};
